var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoursesInactive = function SvgCoursesInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 2",
    viewBox: "0 0 141.46 141.46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "courses-inactive_svg__a",
    x1: 20.72,
    x2: 120.74,
    y1: 120.74,
    y2: 20.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0742c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cba128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#eee36b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "courses-inactive_svg__b",
    x1: 5.78,
    x2: 135.67,
    y1: 70.73,
    y2: 70.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a27320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#eee36b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#cba128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0742c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "courses-inactive_svg__c",
    x1: 29.07,
    x2: 113.69,
    y1: 69.73,
    y2: 69.73,
    "data-name": "New Gradient Swatch 2",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a27320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#eee36b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#cba128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0742c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#courses-inactive_svg__a",
    id: "courses-inactive_svg__d",
    x1: 28.07,
    x2: 114.69,
    y1: 69.73,
    y2: 69.73
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.73 6c35.69 0 64.73 29.04 64.73 64.73s-29.04 64.73-64.73 64.73S6 106.42 6 70.73 35.04 6 70.73 6m0-6C31.67 0 0 31.67 0 70.73s31.67 70.73 70.73 70.73 70.73-31.67 70.73-70.73S109.79 0 70.73 0",
    style: {
      fill: "url(#courses-inactive_svg__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73 11.78c32.5 0 58.95 26.44 58.95 58.95s-26.44 58.95-58.95 58.95-58.95-26.45-58.95-58.95 26.44-58.95 58.95-58.95m0-6c-35.87 0-64.95 29.08-64.95 64.95s29.08 64.95 64.95 64.95 64.95-29.08 64.95-64.95S106.6 5.78 70.73 5.78",
    style: {
      strokeWidth: 0,
      fill: "url(#courses-inactive_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44 57.45 71.29 41.33a1.64 1.64 0 0 0-1.25.02c-17.86 7.76-37.4 15.86-39.15 15.98-.86 0-1.62.72-1.79 1.69-.18.98.28 1.97 1.07 2.37l10.32 5.14v4.92c-1.57.63-2.67 2.37-2.67 4.31 0 .9.23 1.76.65 2.51l-1.36 9.28c-.09.61.06 1.24.41 1.72s.87.75 1.41.75h5.76c.53 0 1.04-.27 1.39-.73s.51-1.07.44-1.68l-1.17-9.74c.29-.65.45-1.37.45-2.12 0-1.47-.6-2.81-1.62-3.67v-3.73l6.37 3.17v21.17c0 3.05 2.17 5.54 4.83 5.54h34.65c2.66 0 4.83-2.49 4.83-5.54v-22.5l17.72-8.82c.71-.35 1.14-1.14 1.11-2.02-.03-.87-.53-1.64-1.25-1.92ZM41.82 75.43c.17 0 .3.16.3.35 0 .03 0 .13-.07.23-.07.09-.14.19-.19.3-.07-.09-.14-.18-.23-.26a.37.37 0 0 1-.11-.27c0-.19.14-.35.3-.35m.1 4.88.66 5.49h-1.47zm29.45-18.64c-1.84 0-2.83-.62-3.1-.91.27-.3 1.27-.91 3.1-.91s2.83.62 3.1.91c-.27.3-1.27.91-3.1.91m-3.94 1.81c1.02.65 2.41 1 3.94 1 3.25 0 5.62-1.57 5.62-3.73s-2.36-3.73-5.62-3.73c-2.5 0-4.51.93-5.28 2.4L42.6 62.97l-6.22-3.1c9.48-3.55 28.24-11.64 34.35-14.29l36.01 14.11-35.36 17.6-22.2-11.05 18.26-2.76Zm-13.2 9.9 16.41 8.17c.47.23 1 .23 1.47 0l19.06-9.49v20.66c0 .73-.51 1.31-1.14 1.31H55.38c-.63 0-1.14-.59-1.14-1.31V73.38Z",
    style: {
      strokeWidth: 0,
      fill: "url(#courses-inactive_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71 41.22c.2 0 .4.04.59.11l41.15 16.12c.72.27 1.22 1.04 1.25 1.91.03.88-.4 1.67-1.11 2.02L94.87 70.2v22.5c0 3.05-2.17 5.54-4.83 5.54H55.39c-2.66 0-4.83-2.49-4.83-5.54V71.53l-6.37-3.17v3.73c1.02.86 1.62 2.21 1.62 3.67 0 .74-.16 1.47-.45 2.12l1.17 9.74c.07.61-.09 1.22-.44 1.68s-.85.73-1.39.73h-5.76c-.54 0-1.06-.27-1.41-.75-.36-.48-.5-1.11-.41-1.72l1.36-9.28c-.42-.75-.65-1.61-.65-2.51 0-1.95 1.09-3.68 2.67-4.31v-4.92L30.18 61.4c-.79-.39-1.25-1.39-1.07-2.37.17-.97.93-1.68 1.79-1.69 1.75-.12 21.29-8.22 39.15-15.98.21-.09.43-.14.65-.14M42.6 62.97l23.49-3.55c.77-1.47 2.78-2.4 5.28-2.4 3.26 0 5.62 1.57 5.62 3.73s-2.37 3.73-5.62 3.73c-1.53 0-2.92-.35-3.94-1l-18.26 2.76 22.2 11.05 35.36-17.6-36.01-14.11c-6.11 2.65-24.87 10.74-34.35 14.29l6.22 3.1m28.77-1.3c1.84 0 2.83-.61 3.1-.91-.27-.29-1.27-.91-3.1-.91s-2.83.61-3.1.91c.27.29 1.27.91 3.1.91m0 20.06c-.25 0-.5-.06-.73-.17l-16.4-8.17v19.34c0 .73.51 1.31 1.14 1.31h34.65c.63 0 1.14-.59 1.14-1.31V72.07L72.1 81.56c-.23.12-.48.17-.73.17M41.85 76.3c.06-.11.12-.2.19-.3s.07-.2.07-.23c0-.19-.14-.35-.3-.35-.17 0-.3.15-.3.34 0 .11.04.2.11.27.09.08.16.17.23.26m.07 4.01v.02l-.8 5.47h1.47l-.66-5.47v-.02m28.78-40.09q-.54 0-1.05.21C50.3 48.83 32.57 56.1 30.84 56.32c-1.32.04-2.46 1.08-2.71 2.51-.26 1.4.42 2.85 1.61 3.44l9.77 4.86v3.68c-1.62.95-2.67 2.85-2.67 4.93 0 .94.21 1.86.61 2.69l-1.32 8.96c-.13.87.09 1.77.6 2.46.53.73 1.34 1.15 2.21 1.15h5.76c.84 0 1.64-.41 2.18-1.12.51-.66.74-1.54.63-2.4l-1.14-9.47c.28-.71.43-1.49.43-2.26 0-1.59-.59-3.06-1.62-4.11v-1.68l4.37 2.17v20.55c0 3.61 2.61 6.54 5.83 6.54h34.65c3.21 0 5.83-2.93 5.83-6.54V70.8l17.16-8.54c1.05-.53 1.7-1.69 1.66-2.95-.04-1.28-.78-2.38-1.88-2.81L71.66 40.39c-.3-.12-.63-.18-.96-.18ZM38.88 59.99c9.84-3.81 26.24-10.88 31.88-13.33l33.53 13.14-32.9 16.38-18.92-9.42 14.78-2.24c1.13.62 2.59.96 4.14.96 3.83 0 6.62-1.99 6.62-4.73s-2.78-4.73-6.62-4.73c-2.61 0-4.8.94-5.89 2.48l-22.72 3.44-3.9-1.94Zm32.51 22.73c.41 0 .81-.1 1.18-.28l17.62-8.77v19.04c0 .21-.12.31-.14.31H55.4s-.14-.1-.14-.31V74.99l14.96 7.45c.37.18.78.28 1.18.28Z",
    style: {
      strokeWidth: 0,
      fill: "url(#courses-inactive_svg__d)"
    }
  })));
};
export default SvgCoursesInactive;